import useAxiosService from './useAxiosService'
import { IDataList, ISearchQuery } from 'interfaces'
import { IResponse } from 'interfaces/services'

export const useSearchQueryService = <T>() => {
  const { post, dele } = useAxiosService()
  const search = async (
    url: string,
    query: ISearchQuery<any>,
    fieldData: string
  ): Promise<IResponse<IDataList<T>>> => {
    const response: any = await post(url, query)
    return {
      ...response,
      data: {
        data: fieldData ? response?.data[fieldData] : response?.data,
        totalItems: response?.data.total_items ?? response?.data?.total,
        res: response
      }
    } as IResponse<IDataList<T>>
  }

  const deleteItem = async (url: string): Promise<IResponse<any>> => {
    const response: any = await dele(url)
    return response
  }

  const postDeleteItem = async (
    url: string,
    query: any
  ): Promise<IResponse<any>> => {
    const response: any = await post(url, query)
    return response
  }

  const deleteItemWithPayload = async (
    url: string,
    query: any
  ): Promise<IResponse<any>> => {
    const response: any = await dele(url, query)
    return response
  }

  return { search, deleteItem, postDeleteItem, deleteItemWithPayload }
}
